/**
 * Extracts the file name from the Content-Disposition header.
 * @param contentDisposition The Content-Disposition header value.
 * @returns The extracted file name, or null if no file name is found.
 */
export function getFileNameFromContentDisposition(
  contentDisposition: string,
): string | null {
  if (!contentDisposition) {
    return null;
  }

  // Match either filename*=UTF-8''encoded-name OR filename="quoted-name" OR filename=unquoted-name
  const fileNameMatch = contentDisposition.match(
    /filename\*=(?:UTF-8'')?([^;\n]+)|filename="([^"]+)"|filename=([^;\n]+)/i,
  );

  if (!fileNameMatch) {
    return null;
  }

  // filename*= group → index 1
  // filename="..." → index 2
  // filename=unquoted → index 3
  const rawFileName = fileNameMatch[1] || fileNameMatch[2] || fileNameMatch[3];

  if (!rawFileName) {
    return null;
  }

  try {
    return decodeURIComponent(rawFileName);
  } catch {
    return rawFileName;
  }
}
